<div class="w-full p-3" *ngIf="currentDriverCompletedLoads$ | async as completedLoads">
  <div>
    <mat-form-field class="w-full">
      <mat-label>Search by Load ID</mat-label>
      <input matInput [formControl]="searchForm" autocomplete="off" />
    </mat-form-field>
    <div class="grid grid-cols-2 lg:grid-cols-5 gap-2">
      <div
        class="text-lg font-bold text-gray-600 ml-2 cursor-pointer flex flex-row justify-start items-center"
        (click)="setSortHeader('uniqueId')"
      >
        Load
        <lohi-sort-indicator [activeColumn]="sortBy === 'uniqueId'" [reversed]="sortReverse"></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 cursor-pointer flex flex-row justify-start items-center"
        (click)="setSortHeader('name')"
      >
        Name
        <lohi-sort-indicator [activeColumn]="sortBy === 'name'" [reversed]="sortReverse"></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold text-gray-600 ml-2 cursor-pointer flex flex-row justify-start items-center"
        (click)="setSortHeader('completedTimestamp')"
      >
        Completed At
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'completedTimestamp'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold cursor-pointer text-gray-600 ml-2 flex flex-row justify-start items-center"
        (click)="setSortHeader('needsAdditionalInfo')"
      >
        Needs Additional Info
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'needsAdditionalInfo'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
      <div
        class="text-lg font-bold cursor-pointer text-gray-600 ml-2 flex flex-row justify-start items-center"
        (click)="setSortHeader('needsAdditionalUpload')"
      >
        Needs Additional Upload
        <lohi-sort-indicator
          [activeColumn]="sortBy === 'needsAdditionalUpload'"
          [reversed]="sortReverse"
        ></lohi-sort-indicator>
      </div>
    </div>
    <ng-container *ngIf="completedLoads.length; else noCompleteLoads">
      <a
        class="grid grid-cols-2 lg:grid-cols-5 gap-2 py-2 items-center even:bg-gray-300"
        [routerLink]="['/', 'loads', load.uniqueId]"
        *ngFor="let load of completedLoads; trackBy: completedLoads | trackByKey2: 'uniqueId'"
      >
        <div class="font-bold ml-2">{{ load.uniqueId }}</div>
        <div class="text-gray-700 ml-2">{{ load.name }}</div>
        <div class="text-gray-600 ml-2">Completed at {{ load.completedTimestamp | standardDate }}</div>
        <div class="text-red-500 font-bold ml-2" *ngIf="load.needsAdditionalInfo">{{ load.needsAdditionalInfo }}</div>
        <div class="text-red-500 font-bold ml-2" *ngIf="load.needsAdditionalUpload">
          {{ load.needsAdditionalUpload }}
        </div>
      </a>
    </ng-container>
  </div>
</div>

<ng-template #noCompleteLoads
  ><div class="text-gray-600 w-full h-full flex justify-center items-center">
    Driver does not have any completed loads
  </div></ng-template
>
